module.exports = MaterialUI.Grow;